import { render } from "./product-details.vue?vue&type=template&id=49dc1fcb&scoped=true"
import script from "./product-details.vue?vue&type=script&lang=js"
export * from "./product-details.vue?vue&type=script&lang=js"

import "./product-details.vue?vue&type=style&index=0&id=49dc1fcb&scoped=true&lang=css"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49dc1fcb"]])

export default __exports__